import React from 'react';
import { IdentifiedProfileResponse } from '../../../../api/DTO/IdentifiedProfileResponse';
import { useAiSearchProfilePopoutContext } from '../../../AiSearchProfilePopout/AiSearchProfilePopoutContext';

const CandidateCell = (data: IdentifiedProfileResponse) => {
    const { openProfilePopout } = useAiSearchProfilePopoutContext();
    const { id, profile, searchCriteriaScores } = data;

    const handleOnClick = () => {
        openProfilePopout({
            id,
            education: profile.education,
            experience: profile.experience,
            location: profile.location,
            name: profile.name,
            about: profile.about,
            url: profile.url,
            searchCriteriaScores,
            languages: profile.languages,
        });
    };

    return (
        <div
            data-cy="candidateCell"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                e.preventDefault();
                if (e.key === 'Enter' || e.key === ' ') {
                    handleOnClick();
                }
            }}
            className="text-primary cursor-pointer overflow-hidden text-sm font-bold text-ellipsis"
            onClick={handleOnClick}
        >
            {/* TODO: 6224 - validate if name should be nullable */}
            {profile.name || ''}
        </div>
    );
};

export default CandidateCell;
